import {
  alfredIntegrations,
  ConnectorConnectBody,
  ConnectorConnectResponse,
  ConnectorsResponse,
  ConnectorToolsResponse,
  IntegrationsStatusResponse,
  MicrosoftConnectBody,
  MicrosoftConnectedConvosResponse,
  MicrosoftConnectResponse,
  MicrosoftItemLinkParams,
  MicrosoftItemResponse,
  MicrosoftService,
  RotateConnectorKeyBody,
  RotateConnectorKeyResponse,
} from '@api/api/alfred-integrations';
import { apiFetch } from '@terminal/utils/api-fetch/apiFetch';

export const postMicrosoftConnect = (body: MicrosoftConnectBody) => {
  const { path, schema } = alfredIntegrations.microsoftConnect;
  return apiFetch<MicrosoftConnectResponse>(path, {
    method: 'post',
    body,
    schema,
  });
};

export const deleteMicrosoftDisconnect = (service: MicrosoftService) => {
  const { path } = alfredIntegrations.microsoftDisconnect;
  const params = new URLSearchParams({ service });
  return apiFetch(`${path}?${params}`, { method: 'delete' });
};

export const getServices = () => {
  const { path, schema } = alfredIntegrations.integrationsStatus;
  return apiFetch<IntegrationsStatusResponse>(path, { schema });
};

export const getConnectedConversations = (service: MicrosoftService) => {
  const { path, schema } = alfredIntegrations.microsoftConnectedConvos;
  return apiFetch<MicrosoftConnectedConvosResponse>(path(service), { schema });
};

export const getMicrosoftItemLink = ({
  service,
  itemId,
  conversationId,
}: MicrosoftItemLinkParams) => {
  const { path, schema } = alfredIntegrations.microsoftItemLink;
  return apiFetch<MicrosoftItemResponse>(
    path({ service, itemId, conversationId }),
    { schema }
  );
};

export const getConnectors = () => {
  const { path, schema } = alfredIntegrations.connectors;
  return apiFetch<ConnectorsResponse>(path, { schema });
};

export const postConnectorConnect = (body: ConnectorConnectBody) => {
  const { path, schema } = alfredIntegrations.connectorConnect;
  return apiFetch<ConnectorConnectResponse>(path, {
    method: 'post',
    body,
    schema,
  });
};

export const deleteByoConnector = (connectorId: string) => {
  const { path } = alfredIntegrations.connectorDisconnect;
  return apiFetch(path(connectorId), { method: 'delete' });
};

export const putConnectorRotateKey = (
  connectorId: string,
  body: RotateConnectorKeyBody
) => {
  const { path, schema } = alfredIntegrations.connectorRotateKey;
  return apiFetch<RotateConnectorKeyResponse>(path(connectorId), {
    method: 'put',
    body,
    schema,
  });
};

export const getConnectorTools = (connectorId: string) => {
  const { path, schema } = alfredIntegrations.connectorTools;
  return apiFetch<ConnectorToolsResponse>(path(connectorId), { schema });
};
